import core from "@gtmhub/core/module";
import { ReactionService } from "./services/reaction.service";
import { ReactionWithComments } from "./directives/reactions-with-comments";
import { PostCommentWithAvatarsComponent } from "@gtmhub/experiments/components/post-comment-with-avatars";

export default angular
  .module("experiments", [core])
  .service("ReactionService", ReactionService)
  .component("postCommentWithAvatars", PostCommentWithAvatarsComponent)
  .directive("reactionWithComments", ReactionWithComments.factory()).name;
